"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_query_1 = require("@tanstack/react-query");
const svgs_1 = require("@@/assets/svgs");
const api_1 = require("@/api");
const functions_1 = require("@/common/functions");
const material_ui_confirm_1 = require("material-ui-confirm");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
function default_1({ reviewId }) {
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const open = Boolean(anchorEl);
    const openMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const closeMenu = () => {
        setAnchorEl(null);
    };
    const queryClient = (0, react_query_1.useQueryClient)();
    const onDeleteSuccess = () => {
        queryClient.setQueriesData(['reviewContentsData'], data => data && Object.assign(Object.assign({}, data), { pages: data.pages.map(page => (Object.assign(Object.assign({}, page), { result: page.result.filter(review => review.id !== reviewId) }))) }));
    };
    const deleteReviewAdmin = () => __awaiter(this, void 0, void 0, function* () {
        yield (0, api_1.deleteData)(`/api/v1/order/review/${reviewId}`)
            .then(() => {
            (0, functions_1.showToastMessage)({ message: '삭제 완료' });
            onDeleteSuccess();
        })
            .catch(() => (0, functions_1.showToastMessage)({ message: '삭제 실패' }));
    });
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const deleteReviewConfirm = () => {
        confirm({
            description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["\uC0AD\uC81C\uB294 \uB418\uB3CC\uB9B4 \uC218 \uC5C6\uC5B4\uC694.", (0, jsx_runtime_1.jsx)("br", {}), "\uC815\uB9D0 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC5B4\uC694?"] })),
            confirmationText: '삭제',
        })
            .then(deleteReviewAdmin)
            .catch(() => { });
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ sx: {
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    p: 0,
                }, "aria-controls": open ? 'admin_delete_menu' : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, onClick: openMenu }, { children: (0, jsx_runtime_1.jsx)(svgs_1.MoreVertSvg, { css: { width: '20px', height: '20px' } }) })), (0, jsx_runtime_1.jsx)(Menu_1.default, Object.assign({ id: "admin_delete_menu", anchorEl: anchorEl, autoFocus: false, open: open, onClose: closeMenu, onClick: closeMenu, slotProps: { paper: { sx: { borderRadius: '12px', mt: '4px' } } }, transformOrigin: { horizontal: 'right', vertical: 'top' }, anchorOrigin: { horizontal: 'right', vertical: 'bottom' } }, { children: (0, jsx_runtime_1.jsx)(MenuItem_1.default, Object.assign({ onClick: deleteReviewConfirm, sx: {
                        width: '220px',
                        height: '52px',
                        p: '0 16px',
                        whiteSpace: 'normal',
                        fontSize: '17px',
                        color: 'var(--error-dark)',
                    } }, { children: "\uC0AD\uC81C\uD558\uAE30(\uAD00\uB9AC\uC790)" })) }))] }));
}
exports.default = default_1;
